import React from "react";
import { BurgerStyle } from "../types";

type IconProps = { size?: number; className?: string };

export const Chevron = ({ size = 12, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M2.5 4.5 6 8l3.5-3.5" />
  </svg>
);

export const Check = ({ size = 16, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const Back = ({ size = 20, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M15 5l-7 7 7 7" />
  </svg>
);

const BURGER_PATHS: Record<BurgerStyle, string> = {
  [BurgerStyle.LINES]: "M3 6h18M3 12h18M3 18h18",
  [BurgerStyle.SHORT_LAST]: "M3 6h18M3 12h18M3 18h11",
  [BurgerStyle.SPACED]: "M3 4h18M3 12h18M3 20h18",
};

export const Burger = ({ size = 22, className, variant = BurgerStyle.LINES }: IconProps & { variant?: BurgerStyle }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d={BURGER_PATHS[variant] ?? BURGER_PATHS[BurgerStyle.LINES]} />
  </svg>
);

export const Close = ({ size = 22, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);

export const Arrow = ({ size = 14, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);
